import axios from 'axios';

import { onRequest, onRequestError } from './interceptors/request';
import { onResponse, onResponseError } from './interceptors/response';

function createClient(baseUrl?: string, xApiKey?: string) {
  const client = axios.create({
    baseURL: baseUrl,
    headers: { 'x-api-key': xApiKey },
  });

  client.interceptors.request.use(onRequest, onRequestError);
  client.interceptors.response.use(onResponse, onResponseError(client));

  return client;
}

export { createClient };
